export { default } from './DigAddLanguageModal';

